// This is all data for select control
export const employeeGender = [
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
];
export const payrollPayrunSchedule = [
  { value: 1, label: "First" },
  { value: 2, label: "Second" },
];
export const typeOfContact = [
  { value: 1, label: "Text" },
  { value: 2, label: "Telephone" },
  { value: 3, label: "Email" },
  { value: 4, label: "Website" },
];
export const fullBorderExcel = {
  borderLeft: 2,
  borderRight: 2,
  borderTop: 2,
  borderBottom: 2,
};
export const acceptFile = {
  image: "image/*",
  excel: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  pdf: ".pdf",
};

export const time = [
  {
    label: "Sunrise",
    //   value: ["5:00:00", "6:59:59"],
    value: 1,
  },
  {
    label: "7 - 10h",
    // value: ["7:00:00", "9:59:59"],
    value: 2,
  },
  {
    label: "10 - 13h",
    // value: ["10:00:00", "12:59:59"],
    value: 3,
  },
  {
    label: "13 - 16h",
    // value: ["13:00:00", "15:59:59"],
    value: 4,
  },
  {
    label: "16 - 17:30h",
    // value: ["16:00:00", "17:30:00"],
    value: 5,
  },
];

export const timeDashboard = [
  {
    label: "Sunrise",
    value: ["5:00:00", "6:59:59"],
  },
  {
    label: "7 - 10h",
    value: ["7:00:00", "9:59:59"],
  },
  {
    label: "10 - 13h",
    value: ["10:00:00", "12:59:59"],
  },
  {
    label: "13 - 16h",
    value: ["13:00:00", "15:59:59"],
  },
  {
    label: "16 - 17:30h",
    value: ["16:00:00", "17:30:00"],
  },
];

export const dueDate = [
  {
    label: "Manually",
    value: "manually",
  },
  {
    label: "Today",
    value: "today",
  },
  {
    label: "This Week",
    value: "week",
  },
  {
    label: "This Week To Date",
    value: "this_week_to_date",
  },
  {
    label: "This Month",
    value: "month",
  },
  {
    label: "This Month To Date",
    value: "this_month_to_date",
  },
  {
    label: "This Quarter",
    value: "this_quarter",
  },
  {
    label: "This Quarter To Date",
    value: "this_quarter_to_date",
  },
  {
    label: "This Year",
    value: "year",
  },
  {
    label: "This Year To Date",
    value: "this_year_to_date",
  },
  {
    label: "Last Week",
    value: "last_week",
  },
  {
    label: "Last Week To Date",
    value: "last_week_to_date",
  },
  {
    label: "Last Month",
    value: "last_month",
  },
  {
    label: "Last Month To Date",
    value: "last_month_to_date",
  },
  {
    label: "Last Quarter",
    value: "last_quarter",
  },
  {
    label: "Last Quarter To Date",
    value: "last_quarter_to_date",
  },
  {
    label: "Last Year",
    value: "last_year",
  },
  {
    label: "Last Year To Date",
    value: "last_year_to_date",
  },
  {
    label: "Last 30 days",
    value: "last_30_days",
  },
  {
    label: "Last 365 days",
    value: "last_365_days",
  },
  {
    label: "Next 30 days",
    value: "next_30_days",
  },
  {
    label: "Next 365 days",
    value: "next_365_days",
  },
  {
    label: "Next Week",
    value: "next_week",
  },
  {
    label: "Next 4 Weeks",
    value: "next_4_weeks",
  },
  {
    label: "Next Month",
    value: "next_month",
  },
  {
    label: "Next Quarter",
    value: "next_quarter",
  },
  {
    label: "Next Year",
    value: "next_year",
  },
  {
    label: "To Date",
    value: "toDate",
  },
];

export const payrollColumnUSDForSum = [
  "currentSalary",
  "increaseSalary",
  "newSalary",
  "actualSalary",
  "amountOvertimeDay",
  "amountOvertimeMoney",
  "otherIncentives",
  "bonus",
  "absenceWithRulesDay",
  "absenceWithRulesMoney",
  "absenceWithoutRulesDay",
  "absenceWithoutRulesMoney",
  "otherDeductions",
  "fines",
  "firstSalary",
  "secondSalary",
  "netPayToEmployeeBeforeStatePension",
  "netPayToEmployeeBeforeStatePensionKh",
  "employeeStatePensionKh",
  "employeeStatePension",
  "netPayToEmployeeBeforeTax",
  "taxOnSalary",
  "netPayToEmployeeAfterTax",
  "netPayToEmployeeByCash",
  "netPayToEmployeeByAba",
];

export const top = [
  { value: 3, label: "Top 3 Province" },
  { value: 10, label: "Top 10 Province" },
];
export const topTemple = [
  { value: 5, label: "Top 5 Temple" },
  { value: 10, label: "Top 10 Temple" },
];
export const seasonInYear = [
  { value: [1, 3], label: "៣ខែដើមឆ្នាំ (ត្រីមាសទី១)" },
  { value: [1, 6], label: "៦ខែដើមឆ្នាំ (ឆមាសទី១)" },
  { value: [1, 9], label: "៩ខែដើមឆ្នាំ (បីត្រីមាសដើមឆ្នាំ)" },
  { value: [1, 12], label: "ប្រចាំឆ្នាំ" },
];

export const years = [
  { value: "2025", label: "2025" },
  { value: "2024", label: "2024" },
  { value: "2023", label: "2023" },
  { value: "2022", label: "2022" },
  { value: "2021", label: "2021" },
  { value: "2020", label: "2020" },
  { value: "2019", label: "2019" },
  { value: "2018", label: "2018" },
  { value: "2017", label: "2017" },
  { value: "2016", label: "2016" },
  { value: "2015", label: "2015" },
  { value: "2014", label: "2014" },
  { value: "2013", label: "2013" },
  { value: "2012", label: "2012" },
  { value: "2011", label: "2011" },
  { value: "2010", label: "2010" },
  { value: "2009", label: "2009" },
  { value: "2008", label: "2008" },
  { value: "2007", label: "2007" },
  { value: "2006", label: "2006" },
  { value: "2005", label: "2005" },
  { value: "2004", label: "2004" },
  { value: "2003", label: "2003" },
  { value: "2002", label: "2002" },
  { value: "2001", label: "2001" },
  { value: "2000", label: "2000" },
  { value: "1999", label: "1999" },
  { value: "1998", label: "1998" },
  { value: "1997", label: "1997" },
];
